<template>
  <div id="footer">
    <div class="center socials">
      <a href="https://vimeo.com/user68461223" target="_blank">
        <span class="fa fa-vimeo"></span>
      </a>
      <img src="../../../assets/goj_bildmarke_weiss.svg" style="height: 50px" />
      <a href="https://www.facebook.com/GentsOfJazz/" target="_blank">
        <span class="fa fa-facebook"></span>
      </a>
    </div>
    <div class="center navi">
      <a v-scroll-to="'#about'">About</a> / <a v-scroll-to="'#media'">Media</a> / <a v-scroll-to="'#contact'">Contact</a> / <a @click="$emit('showImprint')">Impressum</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
  #footer {
    background-color: #0d0d0d;
    padding: 5em 0;

    .center {
      margin: 0 auto;
      display: table;

      &.navi {
        padding-top: 2em;
        color: #aaa;
      }

      a {
        color: #aaa;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      &.socials {
        a {
          background-color: white;
          border-radius: 50%;
          display: inline-block;
          padding: 6px;
          margin: 0 1.5em;
          position: relative;
          top: 5px;

          span {
            color: #0d0d0d;
            font-size: 170%;
            width: 25px;
            height: 25px;
            text-align: center;
          }
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/Footer/Footer.vue